import { useTangerineApi } from 'domains/tangerine/hooks'
import { useContext, useMemo } from 'react'
import { PatientContext } from 'ui/contexts'

const useClinicalVisits = () => {
  const { id: patientId } = useContext(PatientContext) || {}

  const path = useMemo(() => {
    if (!patientId) return ''
    return `/api/v3/patients/${patientId}/clinical_visits?limit=1`
  }, [patientId])

  const { data, errors, loading } = useTangerineApi({
    path,
    method: 'GET',
    skip: !patientId || !path,
  })

  // Memoize the processed data to prevent unnecessary re-computations
  const processedData = useMemo(() => {
    // Handle the API response structure - extract the clinical visit from the nested array
    const clinicalVisit = data?.data?.clinical_visits?.[0] || null

    // Check if the clinical visit has pre-visit prep response
    const latestClinicalVisitWithPreVisitPrep =
      clinicalVisit?.pre_visit_prep_response ? clinicalVisit : null

    // Extract clinician recommendations from the API response
    const clinicianRecommendations =
      clinicalVisit?.clinician_recommendation || null
    const dyskinesiaManagementRecommendation =
      clinicianRecommendations?.['Dyskinesia Management'] || null

    return {
      clinicalVisit,
      latestClinicalVisitWithPreVisitPrep,
      clinicianRecommendations,
      dyskinesiaManagementRecommendation,
    }
  }, [data])

  return {
    ...processedData,
    loading,
    hasError: !!errors?.length,
  }
}

export default useClinicalVisits
